import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {

  @Input() alert: AlertModel;

  constructor() { }

  ngOnInit() {
  }
}

export class AlertModel {
  mensaje: string = '';
  tipo: ETipoAlert = ETipoAlert.primary;
  visible: boolean = false;
  icon?: string;
}

export enum ETipoAlert {
  primary = "primary",
  secondary = "secondary",
  success = "success",
  danger = "danger",
  warning = "warning",
  info = "info",
  light = "light",
  dark = "dark"
}
